au<template>
  <div>
    <div id="oauth-success" class="flex center" style="flex-direction:column">
      <img width="450" src="@/assets/img/happy.png" />
      <h3>Integração realizada com sucesso!</h3>
      <p>
        Selecione no painel as contas da Yampi que você quer sincronizar.
      </p>

      <div class="buttons small">
        <div @click="closeWindow()" class="button secondary">
          Fechar
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import logo5 from "@/assets/img/integration/logo-5.png";

export default {
  name: "yampi-oauth",
  data() {
    return {
      // logo: logo5
    };
  },
  methods: {
    closeWindow() {
      window.open("", "_parent", "");
      window.close();
    },
  },
};
</script>

<style lang="scss" scoped>
#oauth-success {
  padding-top: 30px;
  align-items: center;
  img {
    margin-bottom: 30px;
  }
  .buttons {
    margin-top: 30px;
  }
}
</style>
